import { render, staticRenderFns } from "./LollipopChart.vue?vue&type=template&id=68ab2178"
import script from "./LollipopChart.vue?vue&type=script&lang=js"
export * from "./LollipopChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports